import { jsxs as e, jsx as t } from "react/jsx-runtime";

import i from "../../hook-form/FormSelect.js";

import { startOfDay as a, parse as o, endOfDay as n, format as r, addMinutes as s } from "date-fns";

import { useFormContext as l, useFieldArray as m } from "react-hook-form";

import d from "@ui-components-3/icons/lib/regular/CirclePlus";

import c from "@ui-components-3/icons/lib/regular/TrashCan";

import { useCallback as u, useMemo as f, useEffect as p } from "react";

import x from "@ui-components-3/ui/lib/utils/classNames";

import { useLiveCurrentDate as b } from "../../../hooks/useLiveCurrentDate.js";

import { SCHEDULE_DATE_FORMAT as h, SCHEDULE_TIME_FORMAT as v } from "../../../utils.js";

import { useProviderSchedule as g } from "../../../hooks/useProviderSchedule.js";

const w = ({rootName: m, index: d, onRemove: w}) => {
    const {variantClassNames: N, minTimeSegmentDuration: S, isSubmittingSchedule: D} = g(), {watch: O, trigger: T} = l(), y = `${m}.${d}.startTime`, k = `${m}.${d}.endTime`, C = b(), [j, I, $, R] = O([ y, k, "frequency", "startDate" ]), P = f((() => "daily" === $ && a(new Date(C)).valueOf() === a(o(R, h, new Date)).valueOf()), [ $, C, R ]), q = f((() => ((e = 30) => {
        const t = [];
        let i = a(new Date).valueOf();
        const o = n(new Date).valueOf();
        for (;i <= o; ) t.push(r(new Date(i), v)), i = s(new Date(i), e).valueOf();
        return t;
    })(S)), [ S ]);
    p((() => {
        if (j && I) {
            const e = setTimeout((() => {
                T([ m, k ]);
            }), 100);
            return () => {
                clearTimeout(e);
            };
        }
    }), [ k, I, m, j, T ]);
    const A = u((e => !!P && o(e, v, new Date(C)).valueOf() < C.valueOf()), [ C, P ]), B = f((() => q.findIndex((e => "07:00am" === e))), [ q ]), E = f((() => j ? q.findIndex((e => e === j)) : B), [ j, q, B ]), F = f((() => I ? q.findIndex((e => e === I)) : B), [ I, q, B ]);
    return e("div", {
        className: "flex flex-row gap-2.5",
        children: [ e("div", {
            className: "flex flex-1 flex-row flex-wrap gap-4",
            children: [ t(i, {
                name: y,
                options: q,
                label: "Start Time*",
                className: "min-w-[135px] flex-1",
                disabled: !!D,
                isOptionDisabled: A,
                initialScrollOptionIndex: E
            }), t(i, {
                name: k,
                options: q,
                label: "End Time*",
                className: "min-w-[135px] flex-1",
                disabled: !!D,
                isOptionDisabled: A,
                initialScrollOptionIndex: F
            }) ]
        }), t("button", {
            type: "button",
            className: x("btn-sm mt-5 h-9 w-9 shrink-0 px-0", N.buttonBorderless),
            "aria-label": "Remove Slot",
            onClick: w,
            disabled: !!D,
            children: t(c, {
                "aria-hidden": "true",
                className: "h-[18px] w-[18px]"
            })
        }) ]
    });
}, N = ({name: i}) => {
    const {variantClassNames: a, isSubmittingSchedule: o} = g(), {control: n, formState: {errors: r}, trigger: s} = l(), {fields: c, append: f, remove: p} = m({
        control: n,
        name: i
    }), b = "string" == typeof r?.[i]?.message && r?.[i]?.message || "", h = u((e => () => {
        p(e), s(i);
    }), [ i, p, s ]);
    return e("div", {
        className: "flex flex-col gap-6",
        children: [ c.map(((e, a) => t(w, {
            rootName: i,
            index: a,
            onRemove: h(a)
        }, e.id))), !!b && t("p", {
            className: "typography-body -mt-3 font-medium text-fuchsia-700",
            children: b
        }), e("button", {
            type: "button",
            className: x("btn-md", a.buttonMain),
            onClick: () => f({
                startTime: "",
                endTime: ""
            }),
            disabled: !!o,
            children: [ t(d, {
                "aria-hidden": "true"
            }), "Add Time Slot" ]
        }) ]
    });
};

export { N as default };
//# sourceMappingURL=TimeSlotsField.js.map
